import React from 'react'

import { AuthContext } from '../../main/ProvedorAutenticacao'
import { withRouter } from 'react-router-dom'
import { Toast } from 'primereact/toast';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import Cards from '../../componentes/Pessoas/CardsPainelPessoas'
import Graficos from '../../componentes/Pessoas/Graficos'
import NavBar from '../../componentes/Navbar'

class PainelGrafico extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    
    }
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          <div className="container-fluid">
            <section className="content-header">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="pi pi-user"></i>
                    <span> Painel Gerencial de Pessoas</span>
                  </h3>
                </div>
                <Cards/>
                <Graficos/>
              </div>
            </section>
          </div>
        </div>
      </>
    )
  }
}

PainelGrafico.contextType = AuthContext;
export default withRouter(PainelGrafico)